module.exports = {
      id: "cinema-usage",
      viewBox: "0 0 26.501 25.377",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#cinema",
      toString: function () {
        return this.url;
      }
    }